import { render, staticRenderFns } from "./SaldoRemessaModalManage.vue?vue&type=template&id=bf1ead68&scoped=true"
import script from "./SaldoRemessaModalManage.vue?vue&type=script&lang=js"
export * from "./SaldoRemessaModalManage.vue?vue&type=script&lang=js"
import style0 from "./SaldoRemessaModalManage.vue?vue&type=style&index=0&id=bf1ead68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1ead68",
  null
  
)

export default component.exports